var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SceneFull',{attrs:{"type":_vm.type,"flag":_vm.flag},scopedSlots:_vm._u([{key:"image",fn:function(){return [_c('SouverentySmall')]},proxy:true},{key:"imageFull",fn:function(){return [_c('SouverentyBig')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }